export const keys = {
  me: ['me'] as const,
  health: ['health'] as const,
  overviewAll: ['overview'] as const,
  overview: (params: Record<string, string>) => ['overview', params] as const,
  analytics: (params: Record<string, string>) => ['analytics', params] as const,
  analyticsLongCalls: (params: Record<string, string>) => ['analytics', 'long-calls', params] as const,
  jobs: ['jobs'] as const,
  jobsList: (params: Record<string, string>) => ['jobs', 'list', params] as const,
  jobOptions: (params: Record<string, string> = {}) => ['jobs', 'options', params] as const,
  jobDepartments: ['jobs', 'departments'] as const,
  applyJob: (jobId: string) => ['apply', jobId] as const,
  job: (id: string) => ['jobs', id] as const,
  jobDefaults: ['jobs', 'defaults'] as const,
  jobLookalikes: (params: Record<string, string>) => ['jobs', 'lookalikes', params] as const,
  fit: (jobId: string) => ['jobs', jobId, 'fit'] as const,
  jobRules: (jobId: string) => ['jobs', jobId, 'rules'] as const,
  jobRulesPreview: (jobId: string, draft: string) => ['jobs', jobId, 'rules', 'preview', draft] as const,
  screen: (jobId: string) => ['screens', jobId] as const,
  rubric: (jobId: string) => ['jobs', jobId, 'rubric'] as const,
  agents: (jobId: string) => ['jobs', jobId, 'agents'] as const,
  applicationsAll: ['applications'] as const,
  applications: (params: Record<string, string>) => ['applications', params] as const,
  application: (id: string) => ['applications', id] as const,
  decisionSummary: (jobId: string) => ['applications', 'decisions', jobId] as const,
  calls: (id: string) => ['applications', id, 'calls'] as const,
  scorecard: (id: string) => ['applications', id, 'scorecard'] as const,
  interview: (id: string) => ['applications', id, 'interview'] as const,
  runs: (id: string) => ['applications', id, 'runs'] as const,
  wellfoundCard: (id: string) => ['applications', id, 'wellfound'] as const,
  wellfoundPreview: (ids: string[], stage: string) => ['applications', 'wellfound-preview', stage, ids] as const,
  callsAll: ['calls'] as const,
  live: ['calls', 'live'] as const,
  liveQueue: ['calls', 'queue'] as const,
  connections: ['connections'] as const,
  catalog: ['connections', 'catalog'] as const,
  wellfoundSync: ['connections', 'wellfound-sync'] as const,
  settings: ['settings'] as const,
  uploadSheets: (uploadId: string) => ['uploads', uploadId, 'sheets'] as const,
  library: ['library'] as const,
  libraryList: (archived: boolean) => ['library', 'list', archived] as const,
  unanswered: ['settings', 'unanswered'] as const,
  users: ['users'] as const,
  assignments: ['assignments'] as const,
  assignmentsList: (includeInactive: boolean) => ['assignments', 'list', includeInactive] as const,
  assignmentPreview: (id: string, appId: string, draft: string) => ['assignments', id, 'preview', appId, draft] as const,
  assignmentsSent: (appId: string) => ['assignments', 'sent', appId] as const,
  audit: (page: number) => ['audit', page] as const,
};
